import React, { useState, useEffect } from "react";

export default function DateRangePicker({ startDate, endDate, onChange, preset = "daily" }) {
  // Keep a local preset state so the select shows the currently chosen value.
  const [localPreset, setLocalPreset] = useState(preset || "daily");

  useEffect(() => {
    // If parent changes the preset prop, keep localPreset in sync.
    if (preset && preset !== localPreset) setLocalPreset(preset);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preset]);

  const handleStart = (e) => onChange({ startDate: e.target.value, endDate });
  const handleEnd = (e) => onChange({ startDate, endDate: e.target.value });

  const applyPreset = (type) => {
    setLocalPreset(type);
    const now = new Date();
    const formatDate = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const today = formatDate(now);

    if (type === "daily") return onChange({ startDate: today, endDate: today });
    if (type === "weekly") {
      const day = now.getDay();
      const weekStart = new Date(now);
      weekStart.setDate(now.getDate() - day); // Sunday start
      return onChange({
        startDate: formatDate(weekStart),
        endDate: today,
      });
    }
    if (type === "monthly") {
      const start = `${yyyy}-${mm}-01`;
      return onChange({ startDate: start, endDate: today });
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <select className="ios-select" value={localPreset} onChange={(e) => applyPreset(e.target.value)}>
        <option value="daily">Daily</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
      </select>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <label style={{ color: "white" }}>Start:</label>
        <input type="date" className="form-control" style={{ minWidth: 160, height: 38 }} value={startDate} onChange={handleStart} />
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <label style={{ color: "white" }}>End:</label>
        <input type="date" className="form-control" style={{ minWidth: 160, height: 38 }} value={endDate} onChange={handleEnd} />
      </div>
    </div>
  );
}


